export default "__VITE_ASSET__CP0xPzPg__"